import { render, staticRenderFns } from "./sideMenu.vue?vue&type=template&id=2e86d92e&scoped=true"
import script from "./sideMenu.vue?vue&type=script&lang=js"
export * from "./sideMenu.vue?vue&type=script&lang=js"
import style0 from "./sideMenu.vue?vue&type=style&index=0&id=2e86d92e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e86d92e",
  null
  
)

export default component.exports